import React from 'react'
import HeaderLogo from '../Icons/Logo.png'
import Language from './Language'
import '../styles/header.css'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


function Header() {
  const navigate = useNavigate(); // Initialize the navigate function
  const isAuthenticated = localStorage.getItem('auth_token')


  const handleLogoClick = () => {
    navigate('/'); // Navigate to the root route (Firstpage)
  };

  const handleRegisterClick = () => {
    navigate('/Login')
  }
  const handleViewReportsClick = () => {
    navigate('/ViewReports')
  }

  const handleFaqBtnClick = ()=> {
    navigate('/FAQ')
  }

  return (
    <header>
      <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img src={HeaderLogo} alt="headerlogo" style={{height: '60px'}} />
      </div>
      <div className="lang-login">
        {/* <Language /> */}
        <button className='faqbtn' onClick={handleFaqBtnClick}>FAQ</button>
        {isAuthenticated ? (
          <div className='logout-myreports'>
            <button className='loginbtn' onClick={() => {
              localStorage.removeItem('auth_token')
              navigate('/')
            }}>Log out</button>
            <button onClick={handleViewReportsClick} className='viewmyreportsBTN'>My Reports</button>
          </div>
        ) : (
          <button className='loginbtn' onClick={handleRegisterClick}>Login</button>
        )}
      </div>
    </header>
  )
}

export default Header